import axios from 'axios';
import { toast } from 'react-toastify';
import { axiosPrivate } from 'src/common/axiosProtected';

// const BASE_URL = process.env.REACT_APP_API_URL;

export const Login = async (values) => {
  try {
    const response = await axios.post(`/api/v1/auth/logIn`, values);
    if (response.status !== 200) {
      throw new Error(response.data ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const importCsv = async (values) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/uploads/csv`, values);

    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getAllCustomers = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  try {
    const response = await axiosPrivate.get(`/api/v1/customers/all?${query}`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getCustomer = async (uuid) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/customers/find-one/${uuid}`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getCustomerAddress = async (uuid) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/customer-addresses/find-one/${uuid}`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const deleteCustomerAddress = async (values) => {
  const response = await axiosPrivate.delete(
    `/api/v1/customer-addresses/delete`,
    {
      data: values, // Pass values in the `data` property
    },
  );
  if (response.status !== 200)
    throw new Error(response.data ?? 'Request Failed.');
  return response;
};
export const getCustomerAddresses = async (uuid, params = {}) => {
  try {
    // Set default pagination parameters for proper server-side pagination
    const defaultParams = {
      page: 1,
      limit: 99, // Default to 99 records per page as requested
      ...params,
    };

    const query = new URLSearchParams(defaultParams).toString();
    const response = await axiosPrivate.get(
      `/api/v1/customer-addresses/customer/${uuid}?${query}`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getAllEquipments = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/equipments/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getAllServiceType = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/service-types/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getAllAccessorials = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/accessorials/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getAllTags = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/tags/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getAllCommodities = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/commodities/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getAllMani = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/manifests/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const updateCommodity = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/commodities/update/${values.uuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const createCommodity = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/commodities/create`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const deleteCommodity = async (values) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/commodities/delete`, {
      data: values,
    });

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getAllPaymentTerms = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/payment-terms/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getAllServices = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/services/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getAllEquipmentsTypes = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/equipment-types/active?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getPaymentTypes = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/payment-terms/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getEquipmentSubTypes = async () => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/equipment-subtypes/all?page=1&limit=250`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const createEquipment = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/equipments/create`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const updateEquipment = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/equipments/update/${values.uuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const deleteEquipment = async (values) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/equipments/delete`, {
      data: values, // Pass values in the `data` property
    });

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getAllCarriers = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  try {
    const response = await axiosPrivate.get(`/api/v1/carriers/all?${query}`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getAllLegs = async (params = {}) => {
  const query = params?.params ? `${params.params}` : '';
  try {
    const response = await axiosPrivate.get(`/api/v1/legs/all${query}`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response.data.data;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getOrder = async ({ uuid }) => {
  if (!uuid || uuid === 'undefined' || uuid === undefined) {
    throw new Error('Invalid order UUID provided');
  }
  try {
    const response = await axiosPrivate.get(`/api/v1/orders/find-one/${uuid}`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const AddOrderAccessorials = async (values, orderUuid) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/orders/update/${orderUuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const allocateRevenueAcrossLegs = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/legs/allocate-revenue`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const updateRevenueForLegs = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/legs/update-revenue`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getLegRevenueSummary = async (orderUuid) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/legs/revenue-summary/${orderUuid}`,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const updateLeg = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/legs/update/${values?.uuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const splitLeg = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/legs/split/${values?.uuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const ChangeLegTime = async (values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/legs/change-time/${values?.uuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const createManifest = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/manifests/create`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const setEta = async (values, orderUuid) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/orders/set-eta/${orderUuid}`,
      values,
    );

    return { valid: true, file };
  } catch (error) {
    console.error('Validation Error:', error);
    throw error;
  }
};

/*************  ✨ Codeium Command ⭐  *************/
/**
 * Updates the estimated time of arrival (ETA) for a specific order.
 *
 * @param {Object} values - The ETA details to be updated.
 * @param {string} orderUuid - The unique identifier of the order.
 * @returns {Promise<Object>} The response from the server.
 * @throws Will throw an error if the request fails.
 */
export const getCarrier = async (uuid) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/carriers/find-one/${uuid}`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const getAllManifests = async (params = {}) => {
  try {
    const query = params?.params ? `${params.params}` : '';
    const response = await axiosPrivate.get(`/api/v1/manifests/all${query}`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    // Handle different possible response structures
    let manifests = response.data?.data;
    if (!manifests) {
      // Try alternative structures
      if (Array.isArray(response.data)) {
        manifests = response.data;
      } else if (response.data?.manifests) {
        manifests = response.data.manifests;
      } else if (response.data?.data?.manifests) {
        manifests = response.data.data.manifests;
      }
    }

    return manifests;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getManifestById = async (uuid) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/manifests/find-one/${uuid}`,
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response.data?.data;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const updateCarrier = async (values, carrierUuid) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/carriers/update/${carrierUuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Error updating carrier:', error);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const updateCustomer = async (values, customerUuid) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/customers/update/${customerUuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Error updating carrier:', error);
    throw error;
  }
};
/**
 * Update default addresses for a customer
 * PUT /api/v1/customers/default-addresses/:uuid
 * @param {Object} values - { shipperDefaultAddress?: IAddress[], consigneeDefaultAddress?: IAddress[] }
 * @param {string} customerUuid
 */
export const updateCustomerDefaultAddresses = async (values, customerUuid) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/customers/default-addresses/${customerUuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Error updating customer default addresses:', error);
    throw error;
  }
};
export const createCustomer = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/customers/create`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const createUser = async (values) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/users/create`, values);

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const updateCustomerAddress = async (values, uuid) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/customer-addresses/update/${uuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Error updating carrier:', error);
    throw error;
  }
};
export const AddAddress = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/customer-addresses/create`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Error updating carrier:', error);
    throw error;
  }
};
export const getCustomerPeople = async (uuid) => {
  try {
    const response = await axiosPrivate.get(`/api/v1/people/customer/${uuid}`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const createCustomerPerson = async (values) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/people/create`, values);

    return response;
  } catch (error) {
    console.error('Error Add carrier:', error);
    throw error;
  }
};

export const createCarrierService = async (values, uuid) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/carriers/add-services/${uuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Error Add carrier:', error);
    throw error;
  }
};
export const updatePerson = async (values, uuid) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/people/update/${uuid}`,
      values,
    );

    return response;
  } catch (error) {
    console.error('Error updating carrier:', error);
    throw error;
  }
};

export const deletePerson = async (values) => {
  const response = await axiosPrivate.delete(`/api/v1/people/delete`, {
    data: values, // Pass values in the `data` property
  });
  if (response.status !== 200)
    throw new Error(response.data ?? 'Request Failed.');
  return response;
};
export const createCarrier = async (values) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/carriers/create`, values);

    if (response.status === 200) {
      toast.success(response.data.message || 'Carrier Added successfully.');
      return response.data;
    } else {
      toast.error(response.data.message || 'Request failed.');
      throw new Error(response.data.message || 'Request failed.');
    }
  } catch (error) {
    console.error('Error Add carrier:', error);
    throw error;
  }
};
export const updateService = async (values, serviceId) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/services/update/${serviceId}`,
      values,
    );

    if (response.status === 200) {
      toast.success('service updated successfully.');
      return response.data;
    } else {
      toast.error(response.data.message || 'Something went wrong.');
      throw new Error(response.data.message || 'Request failed.');
    }
  } catch (error) {
    console.error('Error updating service:', error);
    throw error;
  }
};
export const deleteService = async (values) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/services/delete`, {
      data: { uuids: values },
    });

    if (response.status === 200) {
      toast.success('service deleted successfully.');
      return response.data;
    } else {
      toast.error(response.data.message || 'Something went wrong.');
      throw new Error(response.data.message || 'Request failed.');
    }
  } catch (error) {
    console.error('Error updating service:', error);
    throw error;
  }
};

export const getCommodityTypes = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/commodity-types/all`);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const createOrderApi = async (values) => {
  try {
    const response = await axiosPrivate.post(`/api/v1/orders/create`, values);

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response.data.data;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getSingleOrder = async (id) => {
  const response = await axiosPrivate.get(`/api/v1/orders/find-one/${id}`);
  if (response.status !== 200)
    throw new Error(response.data ?? 'Request Failed.');
  return response.data.data;
};

// Document API functions
export const createDocument = async (values) => {
  try {
    // If values contains a file, create FormData
    let requestData = values;
    let headers = {};

    if (values.file) {
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        if (key === 'file') {
          formData.append('documents', values[key]);
        } else {
          formData.append(key, values[key]);
        }
      });
      requestData = formData;
      headers['Content-Type'] = 'multipart/form-data';
    }

    const response = await axiosPrivate.post(
      `/api/v1/documents/create`,
      requestData,
      { headers },
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const updateDocument = async (uuid, values) => {
  try {
    // If values contains a file, create FormData
    let requestData = values;
    let headers = {};

    if (values.file) {
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        if (key === 'file') {
          formData.append('documents', values[key]);
        } else {
          formData.append(key, values[key]);
        }
      });
      requestData = formData;
      headers['Content-Type'] = 'multipart/form-data';
    }

    const response = await axiosPrivate.put(
      `/api/v1/documents/update/${uuid}`,
      requestData,
      { headers },
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const deleteDocument = async (uuid) => {
  try {
    const response = await axiosPrivate.delete(
      `/api/v1/documents/delete/${uuid}`,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};
export const generateBOL = async (uuid, options = {}) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/bol/generate/${uuid}`,
      options,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const generateLabels = async (uuid, options = {}) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/labels/generate/${uuid}`,
      options,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const generateUCC128 = async (uuid, options = {}) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/ucc128/generate/${uuid}`,
      options,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getDocument = async (uuid) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/documents/find-one/${uuid}`,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response.data.data;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getDocuments = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  try {
    const response = await axiosPrivate.get(`/api/v1/documents/all?${query}`);
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getDocumentsByType = async (documentTypeId) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/documents/by-type/${documentTypeId}`,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response.data.data;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getDocumentsByLeg = async (legId) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/documents/by-leg/${legId}`,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response.data.data;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const associateDocumentWithLeg = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/documents/associate-leg`,
      values,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const removeDocumentFromLeg = async (values) => {
  try {
    const response = await axiosPrivate.delete(`/api/v1/documents/remove-leg`, {
      data: values,
    });
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const createOrderDocument = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/documents/order-document`,
      values,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getShipmentDetailsForLawEnforcement = async (orderDocumentId) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/documents/law-enforcement/${orderDocumentId}`,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response.data.data;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getDocumentTypes = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/documents/types`);
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response.data.data;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const uploadDocument = async (file, additionalData = {}) => {
  try {
    const formData = new FormData();
    formData.append('documents', file);

    // Add any additional data to the form
    Object.keys(additionalData).forEach((key) => {
      formData.append(key, additionalData[key]);
    });

    const response = await axiosPrivate.post(
      `/api/v1/documents/create`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    if (response.status !== 200 && response.status !== 201) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

// Add a function to download documents
export const downloadDocument = async (uuid) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/documents/find-one/${uuid}`,
      {
        responseType: 'arraybuffer',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: '*/*',
        },
        transformResponse: [
          (data, headers) => {
            return data;
          },
        ],
      },
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }

    // Ensure headers are accessible
    return {
      ...response,
      headers: response.headers || {},
    };
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

// Add a function to get documents by order ID
export const getDocumentsByOrder = async (orderId) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/documents/all?orderId=${orderId}`,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getManifestLegsWithDocuments = async (manifestUuid) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/manifests/find-one/${manifestUuid}/legs-documents`,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

export const getManifestRunSheet = async (
  manifestUuid,
  { isLineHaul = false } = {},
) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    const accessToken = userData?.token;
    const query = isLineHaul
      ? '?isLineHaul=true&fields=shipperIds,additionalInfo,commodities'
      : '';

    const response = await axiosPrivate.get(
      `${import.meta.env.VITE_API_URL}/api/v1/manifests/${manifestUuid}/run-sheet${query}`,
      {
        headers: {
          'Content-Type': 'application/json',
          ...(accessToken && { token: accessToken }),
        },
        validateStatus: (status) => status === 200 || status === 204,
      },
    );

    // Handle 204 as success
    if (response.status === 204) {
      return { status: 204, data: null };
    }

    return { status: 200, data: response.data };
  } catch (error) {
    console.error('Request Error:', error);

    // Axios error handling
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 204) {
        return { status: 204, data: null };
      }

      throw new Error(
        error.response?.data?.message ||
          error.response?.data ||
          'Request Failed.',
      );
    }

    throw new Error(error.message || 'Request Failed.');
  }
};

// Bulk delete documents - matches DeleteDocumentsDto
export const deleteDocuments = async (uuids) => {
  try {
    const response = await axiosPrivate.delete(
      `/api/v1/documents/bulk-delete`,
      {
        data: { uuids },
      },
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

// Create document type - matches DocumentTypeDto
export const createDocumentType = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/document-types/create`,
      values,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

// Update document type - matches DocumentTypeDto
export const updateDocumentType = async (uuid, values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/document-types/update/${uuid}`,
      values,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

// Delete document type
export const deleteDocumentType = async (uuid) => {
  try {
    const response = await axiosPrivate.delete(
      `/api/v1/document-types/delete/${uuid}`,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

// Get documents with filters - matches DocumentFilterDto
export const getDocumentsWithFilter = async (filters = {}) => {
  const query = new URLSearchParams(filters).toString();
  try {
    const response = await axiosPrivate.get(
      `/api/v1/documents/filter?${query}`,
    );
    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

// Upload multiple documents - supports up to 10 files
export const uploadMultipleDocuments = async (files, additionalData = {}) => {
  try {
    if (!Array.isArray(files) || files.length === 0) {
      throw new Error('At least one file is required');
    }

    if (files.length > 10) {
      throw new Error('Maximum 10 files allowed per upload');
    }

    const formData = new FormData();

    // Append all files with 'documents' field name
    files.forEach((file) => {
      if (file.size > 10485760) {
        // 10MB limit
        throw new Error(`File ${file.name} exceeds 10MB size limit`);
      }
      formData.append('documents', file);
    });

    // Add any additional data to the form
    Object.keys(additionalData).forEach((key) => {
      formData.append(key, additionalData[key]);
    });

    const response = await axiosPrivate.post(
      `/api/v1/documents/create`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    if (response.status !== 200) {
      throw new Error(response.data.message ?? 'Request Failed.');
    }
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw new Error(error.response?.data?.message ?? 'Request Failed.');
  }
};

// Validate file upload - matches FileUploadDto
export const validateFileUpload = async (file, validationRules = {}) => {
  try {
    const {
      allowedTypes = [],
      maxSize = 10485760,
      required = false,
    } = validationRules;

    if (required && !file) {
      throw new Error('File is required');
    }

    if (file) {
      if (allowedTypes.length > 0 && !allowedTypes.includes(file.type)) {
        throw new Error(
          `File type ${
            file.type
          } is not allowed. Allowed types: ${allowedTypes.join(', ')}`,
        );
      }

      if (file.size > maxSize) {
        throw new Error(
          `File size ${file.size} exceeds maximum allowed size of ${maxSize} bytes`,
        );
      }
    }

    return { valid: true, file };
  } catch (error) {
    return { valid: false, error: error.message };
  }
};

export const downloadQuotePdf = async (quoteUuid, orderUuid) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/quotes/download/${quoteUuid}`,
      {
        responseType: 'blob',
        params: {
          orderUuid,
        },
      },
    );

    if (response.status !== 200) {
      throw new Error('Failed to download PDF');
    }

    return response.data;
  } catch (error) {
    console.error('Error downloading PDF:', error);
    throw new Error(error.response?.data?.message ?? 'Failed to download PDF');
  }
};

export const downloadAllDocuments = async (fileIds = [], orderId = null) => {
  try {
    const payload = { fileIds, orderId };

    const response = await axiosPrivate.post(
      `/api/v1/documents/download-all`,
      payload,
      {
        responseType: 'blob',
      },
    );

    if (response.status !== 200) {
      throw new Error('Failed to download documents');
    }

    return response.data;
  } catch (error) {
    console.error('Error downloading documents:', error);
    throw new Error(
      error.response?.data?.message ?? 'Failed to download documents',
    );
  }
};

export const createCustomerEmailContact = async (values) => {
  try {
    const response = await axiosPrivate.post(
      `/api/v1/customer-email-contacts/create`,
      values,
    );
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw error;
  }
};

export const updateCustomerEmailContact = async (uuid, values) => {
  try {
    const response = await axiosPrivate.put(
      `/api/v1/customer-email-contacts/update/${uuid}`,
      values,
    );
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw error;
  }
};

export const deleteCustomerEmailContact = async (uuid) => {
  try {
    const response = await axiosPrivate.delete(
      `/api/v1/customer-email-contacts/delete/${uuid}`,
    );
    return response;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw error;
  }
};

export const getCronJobLogsMeta = async () => {
  try {
    const response = await axiosPrivate.get(`/api/v1/cron-job-logs/meta`);
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? 'Request Failed.');
    }
    return response.data?.data ?? response.data;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw error;
  }
};

export const getCronJobLogs = async (params = {}) => {
  const cleaned = Object.entries(params).filter(
    ([, value]) => value !== undefined && value !== null && value !== '',
  );

  const searchParams = new URLSearchParams();
  cleaned.forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => searchParams.append(key, String(item)));
    } else {
      searchParams.append(key, String(value));
    }
  });

  const query = searchParams.toString();
  try {
    const response = await axiosPrivate.get(
      `/api/v1/cron-job-logs${query ? `?${query}` : ''}`,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? 'Request Failed.');
    }
    return response.data;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw error;
  }
};

export const getCronJobLog = async (uuid) => {
  try {
    const response = await axiosPrivate.get(
      `/api/v1/cron-job-logs/find-one/${uuid}`,
    );
    if (response.status !== 200) {
      throw new Error(response.data?.message ?? 'Request Failed.');
    }
    return response.data?.data;
  } catch (error) {
    console.error('Request Error:', error.response?.data ?? error.message);
    throw error;
  }
};
